import { Symbol } from "../cauldron/reel";

export enum IngredientType {
    Base,
    Slime,
    Herb,
    Root,
    Flower,
    Animal,
    Cheese,
    Dream,
    Emotion,
    Unique
}

// idk how to do this nicer
export const IngredientTypeName = [
    'Base',
    'Slime',
    'Herb',
    'Root',
    'Flower petals',
    'Animal part',
    'Cheese',
    'Dream',
    'Emotion',
    'Unique' // shouldn't appear in list
];

export interface Ingredient {
    name: string;
    desc?: string;
    type: IngredientType;
    cost: number;
    symbols: Symbol[];
    icon: string;
}